import React, { useEffect, useState } from "react";
import classNames from "classnames";
import "./index.scss";

const IntervalControl = ({
    value,
    onChange
}) => {
    const [indexes, setSelectedIndex] = useState([]);

    const isSelected = (items, index) => {
        const item = items.find(i=> i === index);
        return item || item === 0;
    }

    const handleOnSelect = index => {
        const seletedItems = isSelected(indexes, index) ? indexes.filter(f=> f !== index) : indexes.concat(index);

        setSelectedIndex(seletedItems);
        onChange(value.reduce((acc, currentValue, currentIndex)=> {
            if(isSelected(seletedItems, currentIndex))
                acc.push(currentValue);            
            return acc;
        }, []));
    }

    useEffect(()=> {}, [value, indexes]);

    return (
        <div className={classNames("intervalControl")}>
            {value && value.map((val, index)=> (
                <div className={classNames("intervalControlItem", { selected: isSelected(indexes, index) })}
                    onClick={()=> handleOnSelect(index)}
                >
                    {val}
                </div>
            ))}
        </div>
    );
}

export default IntervalControl;